import { render, staticRenderFns } from "./VideoPlayerModal.vue?vue&type=template&id=526e0b5f&scoped=true"
import script from "./VideoPlayerModal.vue?vue&type=script&lang=js"
export * from "./VideoPlayerModal.vue?vue&type=script&lang=js"
import style0 from "./VideoPlayerModal.vue?vue&type=style&index=0&id=526e0b5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526e0b5f",
  null
  
)

export default component.exports